document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-vz-bundle-add]');
  if (!button) return;
  event.preventDefault();

  const box = button.closest('.vz-bundle');
  const errorBox = box && box.querySelector('[data-vz-bundle-error]');
  const label = button.querySelector('span');
  const original = label ? label.textContent : '';
  const cart = document.querySelector('cart-drawer');
  const sections =
    cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map((section) => section.id)
      : [];

  button.disabled = true;
  button.classList.add('is-loading');
  if (errorBox) errorBox.hidden = true;

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variant), quantity: Number(button.dataset.qty) }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const state = await response.json();
    if (!response.ok) {
      throw new Error(state.description || 'Nie udało się dodać zestawu.');
    }
    if (label) label.textContent = 'Dodano!';
    if (cart && typeof cart.renderContents === 'function') {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(state);
    } else {
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  } catch (error) {
    if (errorBox) {
      errorBox.textContent = error.message;
      errorBox.hidden = false;
    }
    if (label) label.textContent = original;
  } finally {
    setTimeout(() => {
      button.disabled = false;
      button.classList.remove('is-loading');
      if (label) label.textContent = original;
    }, 1600);
  }
});


/* Slider propozycji w koszyku: strzałki i przeciąganie myszą (desktop) */
(function () {
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-vz-slide]');
    if (!arrow) return;
    var list = arrow.closest('.vz-upsell__slider').querySelector('[data-vz-slider]');
    var item = list.querySelector('.vz-upsell__item');
    var step = item ? item.getBoundingClientRect().width + 10 : list.clientWidth * 0.7;
    list.scrollBy({ left: step * Number(arrow.getAttribute('data-vz-slide')), behavior: 'smooth' });
  });

  var drag = null;
  document.addEventListener('mousedown', function (e) {
    var list = e.target.closest('[data-vz-slider]');
    if (!list || e.button !== 0 || e.target.closest('button')) return;
    drag = { list: list, x: e.clientX, left: list.scrollLeft, moved: false };
    list.classList.add('is-dragging');
  });
  document.addEventListener('mousemove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 4) drag.moved = true;
    drag.list.scrollLeft = drag.left - dx;
  });
  function stop() {
    if (!drag) return;
    drag.list.classList.remove('is-dragging');
    var l = drag.list, moved = drag.moved;
    drag = null;
    if (moved) {
      var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      l.addEventListener('click', block, { capture: true, once: true });
      setTimeout(function () { l.removeEventListener('click', block, true); }, 0);
    }
  }
  document.addEventListener('mouseup', stop);
  document.addEventListener('mouseleave', stop);
})();


/* Koszyk: po powrocie na stronę (przycisk Wstecz, bfcache) zamknij szufladę i zdejmij przyciemnienie */
(function () {
  function resetCart() {
    document.querySelectorAll('cart-drawer').forEach(function (drawer) {
      drawer.classList.remove('active', 'animate');
    });
    document.body.classList.remove('overflow-hidden');
  }
  window.addEventListener('pageshow', resetCart);
  window.addEventListener('pagehide', resetCart);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart__checkout-button, [name="checkout"]')) resetCart();
  });
})();


/* Przypięty pasek zakupu na stronie produktu (telefon) */
(function () {
  function init() {
    var submit = document.querySelector('#MainContent product-component .product-form__submit');
    if (!submit || document.querySelector('.vz-sticky-atc')) return;

    var title = document.querySelector('#MainContent product-component .product__title h1');
    var media = document.querySelector('#MainContent product-component .product__media img');

    var bar = document.createElement('div');
    bar.className = 'vz-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    function make(tag, cls) {
      var el = document.createElement(tag);
      el.className = cls;
      return el;
    }
    var og = document.querySelector('meta[property="og:image"]');
    var imgSrc = (media && (media.currentSrc || media.src)) || (og && og.content) || '';
    if (imgSrc) {
      var img = make('img', 'vz-sticky-atc__img');
      img.alt = '';
      img.width = 48;
      img.height = 48;
      img.src = imgSrc;
      bar.appendChild(img);
    }
    var info = make('div', 'vz-sticky-atc__info');
    var titleEl = make('span', 'vz-sticky-atc__title');
    var priceEl = make('span', 'vz-sticky-atc__price');
    info.appendChild(titleEl);
    info.appendChild(priceEl);
    bar.appendChild(info);
    var btn = make('button', 'vz-sticky-atc__btn');
    btn.type = 'button';
    btn.tabIndex = -1;
    bar.appendChild(btn);
    document.body.appendChild(bar);
    titleEl.textContent = title ? title.textContent.trim() : '';

    function sync() {
      var priceNode = document.querySelector('#MainContent product-component [id^="price-"] .price-item--sale, #MainContent product-component [id^="price-"] .price-item--regular');
      var label = submit.querySelector('span');
      priceEl.textContent = priceNode ? priceNode.textContent.trim() : '';
      btn.textContent = label ? label.textContent.trim() : 'Dodaj do koszyka';
      btn.disabled = submit.disabled;
    }
    sync();

    var priceBox = document.querySelector('#MainContent product-component [id^="price-"]');
    if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });

    btn.addEventListener('click', function () {
      submit.click();
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 450);
    });

    // pasek pojawia się dopiero po przewinięciu kawałka strony i gdy główny przycisk nie jest widoczny
    var buttonInView = false;
    function update() {
      var show = !buttonInView && window.scrollY > 320;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('vz-has-sticky-atc', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buttonInView = entries[0].isIntersecting;
        update();
      }, { threshold: 0.1 }).observe(submit);
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
